import { formatCount } from './digits.js';

/**
 * List totals (AC §18.19.3): an opt-in, capped, exact count on the first page (`page.total`). The
 * client never estimates or adds counts; it shows the server's `count`, and a capped total as «بیش
 * از …» with the server's cap value.
 */

/** `PageTotal` (AC §18.19.3): `count = min(n, cap)`, `capped = n > cap`. */
export interface PageTotalValue {
  readonly capped: boolean;
  readonly count: number;
}

/** `{ count: 52, capped: false }` → `۵۲`; `{ count: 10000, capped: true }` → `بیش از ۱۰٬۰۰۰`. */
export function formatPageTotal(total: PageTotalValue): string {
  return total.capped ? `بیش از ${formatCount(total.count)}` : formatCount(total.count);
}

/**
 * The list footer (prototype `.table-footer`, «نمایش ۱ تا ۵ از ۵۸۴»): the number of rows loaded with
 * cursor pagination and, when the first page carried one, the server total. `undefined` when nothing
 * is shown.
 */
export function formatPageRange(shown: number, total?: PageTotalValue): string | undefined {
  if (shown <= 0) {
    return undefined;
  }
  const range = `نمایش ${formatCount(1)} تا ${formatCount(shown)}`;
  return total === undefined ? range : `${range} از ${formatPageTotal(total)}`;
}
